import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/check-icon-primary.svg'
import _imports_1 from '@/assets/images/docusign-logo.jpg'


const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = {
  key: 1,
  class: "spinner spinner-small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"docusign-logo-wr\" data-v-65f1b25b><div class=\"checkmark\" data-v-65f1b25b><img src=\"" + _imports_0 + "\" data-v-65f1b25b></div><img class=\"docusign-logo\" src=\"" + _imports_1 + "\" data-v-65f1b25b></div><div class=\"info-wr\" data-v-65f1b25b><h1 data-v-65f1b25b>You&#39;ve successfully linked your DocuSign account.</h1><p data-v-65f1b25b>You can now generate contracts and send them out for signature via DocuSign.</p></div>", 2)),
    ($setup.isTokenReady)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "button button primary",
          type: "button",
          onClick: $setup.onBack
        }, "Get Started"))
      : _createCommentVNode("", true),
    (!$setup.isTokenReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}